import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { ModeToggle } from "@/components/ui/mode-toggle";
import { tailwind } from "@/utilities/tailwind-utils";
import { NavUser } from "./nav-user";
import { NavBreadcrumb } from "./nav-breadcrumb";
import { NotificationCenter } from "./notification-center";
import { HeaderVerification } from "./header-verification";

export function AppHeader() {
  return (
    <header className={tailwind.components.header}>
      <div className={tailwind.components.headerContent}>
        <SidebarTrigger className={tailwind.spacing.negMl1} />
        <Separator
          orientation="vertical"
          className={tailwind.components.separatorVertical}
        />
        <NavBreadcrumb />
        <div className={tailwind.components.headerActions}>
          <HeaderVerification />
          <NotificationCenter />
          <ModeToggle />
          <NavUser variant="header" />
        </div>
      </div>
    </header>
  );
}
